'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var basicPrefixCls = 'date-panel';
var getCls = function getCls(prefix, basic, suffix) {
  return [prefix + '-' + basic, basic].map(function (item) {
    return '' + item + suffix;
  }).join(' ');
};

/**
 * 显示日期日历
 * props.value
 * props.prefixCls
 * props.onSelect
 * props.disabledDate
 *
 */
var DatePanel = (_temp = _class = function (_Component) {
  _inherits(DatePanel, _Component);

  function DatePanel() {
    _classCallCheck(this, DatePanel);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(DatePanel).apply(this, arguments));
  }

  _createClass(DatePanel, [{
    key: 'render',
    value: function render() {
      //className
      var prefixCls = this.props.prefixCls;

      var panelCls = getCls(prefixCls, basicPrefixCls, '');

      return _react2.default.createElement(
        'div',
        { className: panelCls },
        this._getDateHeader(),
        this._getDateContent()
      );
    }
  }, {
    key: '_getDateHeader',
    value: function _getDateHeader() {
      //className
      var prefixCls = this.props.prefixCls;

      var headerCls = getCls(prefixCls, basicPrefixCls, '-header');
      var dataWrapperCls = getCls(prefixCls, basicPrefixCls, '-data-wrapper');

      var weekNames = ['一', '二', '三', '四', '五', '六', '日'];

      return _react2.default.createElement(
        'div',
        { className: headerCls },
        weekNames.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            { key: i, className: dataWrapperCls },
            item
          );
        })
      );
    }
  }, {
    key: '_getDateContent',
    value: function _getDateContent() {
      var _this2 = this;

      var _props = this.props;
      var value = _props.value;
      var onSelect = _props.onSelect;
      var disabledDate = _props.disabledDate;
      var prefixCls = _props.prefixCls;

      //className

      var contentCls = getCls(prefixCls, basicPrefixCls, '-content');
      var dataWrapperCls = getCls(prefixCls, basicPrefixCls, '-data-wrapper');
      var dataCls = getCls(prefixCls, basicPrefixCls, '-data');

      var date = new Date(value);

      // 设置为本月1日，得到星期几和本月月份
      date.setDate(1);
      var firstDayOfCurMonthInWeek = date.getDay();
      var curMonth = date.getMonth();
      var yearOfCurMonth = date.getFullYear();

      // 向前拨一天，得到上月最后一日、上月月份、上月年份
      date.setHours(date.getHours() - 24);
      var lastDateOfPrevMonth = date.getDate();
      var prevMonth = date.getMonth();
      var yearOfPrevMonth = date.getFullYear();

      // 设置为下月1日，得到下月月份、下月年份
      date.setDate(1);
      date.setMonth(date.getMonth() + 2);
      var nextMonth = date.getMonth();
      var yearOfNextMonth = date.getFullYear();

      // 向前拨一天，得到本月最后一日
      date.setHours(date.getHours() - 24);
      var lastDateOfCurMonth = date.getDate();

      var dates = [],
          dateIterator = lastDateOfPrevMonth;
      date.setFullYear(yearOfPrevMonth, prevMonth, dateIterator);
      //日历是从周一到周日，这里需要转换才能算出上月要补多少天
      var datesNumberOfPrevMonth = firstDayOfCurMonthInWeek == 0 ? firstDayOfCurMonthInWeek + 6 : firstDayOfCurMonthInWeek - 1;
      for (var i = datesNumberOfPrevMonth; i > 0; i--) {
        //补齐上月日期
        dates.unshift({
          current: false,
          year: date.getFullYear(),
          month: date.getMonth(),
          date: date.getDate(),
          ts: date.getTime()
        });
        date.setDate(--dateIterator);
      }

      dateIterator = 1;
      date.setFullYear(yearOfCurMonth, curMonth, dateIterator);
      for (var _i = 1; _i <= lastDateOfCurMonth; _i++) {
        //本月日期
        dates.push({
          current: true,
          year: date.getFullYear(),
          month: date.getMonth(),
          date: date.getDate(),
          ts: date.getTime()
        });
        date.setDate(++dateIterator);
      }

      // 固定显示6行，每行7天
      var numberOfRows = 6;
      var numberOfColumns = 7;
      var daysToFixed = numberOfRows * numberOfColumns - dates.length;
      dateIterator = 1;
      date.setFullYear(yearOfNextMonth, nextMonth, dateIterator);
      for (var _i2 = 1; _i2 <= daysToFixed; _i2++) {
        //补齐下月日期
        dates.push({
          current: false,
          year: date.getFullYear(),
          month: date.getMonth(),
          date: date.getDate(),
          ts: date.getTime()
        });
        date.setDate(++dateIterator);
      }

      var today = new Date();
      date.setTime(value);
      var rows = [];

      var _loop = function _loop(_i3) {
        var rowParts = dates.slice(_i3 * numberOfColumns, (_i3 + 1) * numberOfColumns);
        //记录同行上一个日期是否不可用
        var lastDisabled = false;
        var everyRow = rowParts.map(function (item, i) {
          var isDisabled = !!(disabledDate && disabledDate(item.ts));
          var nextDisabled = !!(disabledDate && rowParts[i + 1] && disabledDate(rowParts[i + 1].ts));
          var content = _react2.default.createElement(
            'div',
            { key: i,
              className: (0, _classnames2.default)(dataWrapperCls, {
                'not-current-month': !item.current,
                'is-today': item.year == today.getFullYear() && item.month == today.getMonth() && item.date == today.getDate(),
                'selected-date': item.year == date.getFullYear() && item.month == date.getMonth() && item.date == date.getDate(),
                'disabled-date': isDisabled,
                'disabled-date-start': isDisabled && !lastDisabled,
                'disabled-date-end': isDisabled && !nextDisabled
              }) },
            _react2.default.createElement(
              'div',
              { className: dataCls,
                onClick: !isDisabled && onSelect.bind(_this2, item.ts) },
              item.date
            )
          );
          lastDisabled = isDisabled;
          return content;
        });
        rows.push(everyRow);
      };

      for (var _i3 = 0; _i3 < numberOfRows; _i3++) {
        _loop(_i3);
      }

      var dateContent = rows.map(function (row, i) {
        return _react2.default.createElement(
          'div',
          { key: i, className: prefixCls + '-' + basicPrefixCls + '-row' },
          row
        );
      });

      return _react2.default.createElement(
        'div',
        { className: contentCls },
        dateContent
      );
    }
  }]);

  return DatePanel;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.number,
  prefixCls: _propTypes2.default.string,
  onSelect: _propTypes2.default.func,
  disabledDate: _propTypes2.default.func
}, _class.defaultProps = {
  prefixCls: 'mt'
}, _temp);
exports.default = DatePanel;